/**
 * Registro de colunas/filtros por fonte de dados do relatório.
 */

import {
  COLUMNS_CONFIG,
  FILTER_EXCLUDED_IDS,
} from './relatoriosColumns';
import {
  COLUMNS_CONFIG_PARQUE,
  FILTER_EXCLUDED_IDS_PARQUE,
  DEFAULT_VISIBLE_IDS_PARQUE,
  GROUP_EXCLUDE_IDS_PARQUE,
  GROUP_ALWAYS_IDS_PARQUE,
} from './relatoriosColumnsParqueLocado';
import {
  COLUMNS_CONFIG_PRODUCAO,
  FILTER_EXCLUDED_IDS_PRODUCAO,
} from './relatoriosColumnsProducaoVolumetria';
import {
  FONTE_CHAMADOS_TECNICOS,
  FONTE_PARQUE_LOCADO,
  FONTE_PRODUCAO_VOLUMETRIA,
} from './relatoriosFontes';

const DEFAULT_VISIBLE_CHAMADOS = [
  'os',
  'tipo',
  'abertura',
  'cliente',
  'solicitante',
  'motivo',
  'tecnico',
  'condicaoFinal',
  'fechamento',
  'laudo',
];

const GROUP_EXCLUDE_CHAMADOS = ['motivo', 'laudo'];
const GROUP_ALWAYS_CHAMADOS = [
  'defeito',
  'empresa',
  'grupoEconomico',
  'contrato',
  'equipamento',
  'area',
  'coordenador',
  'status',
  'logradouro',
  'bairro',
  'cidade',
  'uf',
];

const REGISTRY = {
  [FONTE_CHAMADOS_TECNICOS]: {
    columns: COLUMNS_CONFIG,
    filterExcluded: FILTER_EXCLUDED_IDS,
    defaultVisible: DEFAULT_VISIBLE_CHAMADOS,
    groupExclude: GROUP_EXCLUDE_CHAMADOS,
    groupAlways: GROUP_ALWAYS_CHAMADOS,
    periodDateFieldLabels: { abertura: 'Abertura', fechamento: 'Fechamento' },
  },
  [FONTE_PARQUE_LOCADO]: {
    columns: COLUMNS_CONFIG_PARQUE,
    filterExcluded: FILTER_EXCLUDED_IDS_PARQUE,
    defaultVisible: DEFAULT_VISIBLE_IDS_PARQUE,
    groupExclude: GROUP_EXCLUDE_IDS_PARQUE,
    groupAlways: GROUP_ALWAYS_IDS_PARQUE,
    periodDateFieldLabels: { abertura: 'Instalação', fechamento: 'Desinstalação' },
  },
  [FONTE_PRODUCAO_VOLUMETRIA]: {
    columns: COLUMNS_CONFIG_PRODUCAO,
    filterExcluded: FILTER_EXCLUDED_IDS_PRODUCAO,
    defaultVisible: [],
    groupExclude: FILTER_EXCLUDED_IDS_PRODUCAO,
    groupAlways: [],
    periodDateFieldLabels: { abertura: 'Início', fechamento: 'Fim' },
  },
};

export function getRelatoriosColumnSet(fonteDados) {
  return REGISTRY[fonteDados] || REGISTRY[FONTE_CHAMADOS_TECNICOS];
}

export function getColumnsConfig(fonteDados) {
  return getRelatoriosColumnSet(fonteDados).columns;
}
